import { Component, inject, Input, OnChanges } from '@angular/core';
import { PartnerFormField, PartnerFormService } from './partner-form.service';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormInputComponent } from '@ui/form/form-input/form-input.component';
import { FormTextareaComponent } from '@ui/form/form-textarea/form-textarea.component';
import { ButtonModule } from '@ui/form/button/button.module';
import { ButtonRowModule } from '@ui/form/button-row/button-row.module';
import { AbstractFormComponent } from '@ui/base/abstract-form/abstract-form.component';
import { FormSelectComponent } from '@ui/form/form-select/form-select.component';
import { B2BVisOrgListResponse } from '@api/models/B2bService/Contract/B2bPartner/b-2-b-vis-org-list-response';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'users-partner-form',
    imports: [
        ReactiveFormsModule,
        FormInputComponent,
        FormTextareaComponent,
        ButtonModule,
        ButtonRowModule,
        FormSelectComponent,
        TranslatePipe,
    ],
    templateUrl: './partner-form.component.html',
    styleUrl: './partner-form.component.scss',
    providers: [PartnerFormService],
})
export class PartnerFormComponent extends AbstractFormComponent implements OnChanges {
    @Input() public organizations: B2BVisOrgListResponse[];

    @Input() public set partner(partner: B2BVisOrgListResponse) {
        this.#partnerFormService.patchFormByOrg(partner);
        this.partnerOrgId = partner?.orgId;
    }

    private partnerOrgId: number;

    readonly #partnerFormService: PartnerFormService = inject(PartnerFormService);

    public readonly form: FormGroup = this.#partnerFormService.createReactiveForm();
    public readonly partnerFormField: typeof PartnerFormField = PartnerFormField;

    public handlerCreate: () => void = () => {
        this.handlers.handlerCreate(this.#partnerFormService.prepareFormDataBeforeSubmit());
    };

    public handlerSave: () => void = () =>
        this.handlers.handlerSave(this.#partnerFormService.prepareFormDataBeforeSubmit(this.partnerOrgId));

    public ngOnChanges(): void {
        if (this.lyView) {
            this.form.disable();
        }
    }
}
